export default "/images/arrow-left-square.svg?e2986d454a5218ec0dc76faeaa1761b7";